import type { FC } from 'react';
import React from 'react';
import { Helmet } from 'react-helmet';

import type { IMetaTitleProps } from './models';

export const MetaTitle: FC<IMetaTitleProps> = ({ title }) => (
    <Helmet>
        <title>{title}</title>
    </Helmet>
);
